import React, { useEffect, useRef, useState } from "react";
import TextInput from "../../../../common/TextInput";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import {
  StachHolderTypes,
  AddStackHolderHeader,
  UpdateStackHolderHeader,
  GetHeaderInfo,
  GetAddressList,
} from "../../../../services/StakeholderApi";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import Snackbar from "../../../../common/Snackbar";
import StackHolderAddressList from "./StackHolderAddressList";
import StakeHolderTabs from "./StakeholderTabs";
import AddStakeHolderContact from "./StakeHolderContact";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import AccordionComponent from "../../../../common/Accordion";
import {
  Button,
  Form,
  InputGroup,
  Offcanvas,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import OverlayDrawer from "../../../../common/OverlayDrawer";
import DataTable from "../../../../common/DataTable";
import moment from "moment";
import {
  CONTACT_LOG_HEADERS,
  STAKEHOLDER_LOG_HEADERS,
} from "../actions/Constant";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import StakeholderPreference from "./StakeholderPreference";
import { STAKEHOLDER_TYPE } from "../../../../common/Constant";
import { PARTIES_MASTER_ACTIONS } from "../../../../common/EventConstant";


// Helper function to determine file type from URL
const getFileTypeFromUrl = (url: string): string => {
  const extension = url.split('.').pop()?.toLowerCase() || '';
  switch (extension) {
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    case 'gif':
      return 'image/gif';
    case 'webp':
      return 'image/webp';
    case 'svg':
      return 'image/svg+xml';
    default:
      return 'image/jpeg'; // default
  }
};

interface AddNewTeamProps {
  userData: any; // Holds stakeholder data (can be empty for "Add")
  action: string; // Determines the current action: "Add", "Edit", or "View"
  onCancel: () => void;
}

export const StakeholderHeader: React.FC<AddNewTeamProps> = ({
  userData,
  action: initialAction,
  onCancel,
}) => {
  const [entityName, setEntityName] = useState("");
  const [showEntityName, setShowEntityName] = useState("");
  const [stakeholderTypeId, setStakeholderTypeId] = useState("");
  const [stakeholderLabelTypeId, setStakeholderLabelTypeId] = useState("");
  const [comments, setComments] = useState("");
  const [typeOption, setTypeOption] = useState<
    { value: string; label: string }[]
  >([]);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [action, setAction] = useState(initialAction);
  const [currentUserData, setCurrentUserData] = useState(userData);
  const [isActive, setIsActive] = useState(true);
  const [isAddressPage, setisAddressPage] = useState(false);
  const [stakeholderId, setstakeholderId] = useState("");
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [showDetails, setShowDetails] = useState(false);
  const [modifiedby, setmodifiedby] = useState("");
  const [createdby, setcreatedby] = useState("");
  const [createdon, setcreatedon] = useState("");
  const [modifiedon, setmodifiedon] = useState("");
  const [addressList, setAddressList] = useState<any[]>([]);
  const [selectedTab, setSelectedTab] = useState("Address");
  const [activeKey, setActiveKey] = useState<string | null>("0");
  const [addressDetails, setAddressDetails] = useState<any[]>([]);
  const [selectedStakeholderLabel, setSelectedStakeholderLabel] = useState<
    string | null
  >(null);
  // Fetch Stakeholder Types for Dropdown (Runs Once)

  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures
  );

  const editContact = allowedFeatures.has(PARTIES_MASTER_ACTIONS.CONTACT_EDIT);
  const [selectedPartyType, setSelectedPartyType] = useState("");
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [uploadedFiles, setUploadedFiles] = useState<any[]>([]);
  const [isAddFiles, setIsAddFiles] = useState<boolean>(false);
  const [selectedImg, setSelectedImg] = useState<any>([]);
  const [fileInputValue, setFileInputValue] = useState("");

  useEffect(() => {
    const fetchDropdownOptions = async () => {
      try {
        const response = await StachHolderTypes({
          groupName: "Stakeholder_Types",
          triggerById: Number(loggedInUserid),
        });

        const formattedOptions = response.result.map((item: any) => ({
          value: String(item.pickListItemId), // Ensure values are strings
          label: item.displayName,
        }));

        setTypeOption(formattedOptions);
      } catch (error) {
        console.error("Error fetching stakeholder types:", error);
        setSnackbarMessage("Error fetching stakeholder types");
        setError("error");
        setSnackbarOpen(true);
      }
    };

    fetchDropdownOptions();
  }, [loggedInUserid]);

  // Load Stakeholder Data for Edit Mode
  useEffect(() => {
    const fetchHeaderInfo = async () => {
      try {
        if (action === "Edit" && currentUserData?.stakeholderid) {
          const responseData = await GetHeaderInfo(
            Number(currentUserData.stakeholderid)
          );

          setEntityName(responseData.result.entityname || "");
          setShowEntityName(responseData.result.entityname || "");
          setStakeholderTypeId(String(responseData.result.stakeholdertypeid));
          setStakeholderLabelTypeId(
            String(responseData.result.stakeholdertypeid)
          );
          // Ensure string for dropdown binding
          setComments(responseData.result.comments || "");
          setIsActive(responseData.result.isactive); // Convert API response (1/0) to boolean
          setcreatedby(responseData.result.createdbyname);

          setmodifiedby(responseData.result.modifiedbyname);
          const formattedCreatedDate = moment(
            responseData.result.createddate
          ).format("MM/DD/YYYY | HH:mm");
          const formattedModifiedDate = moment(
            responseData.result.modifieddate
          ).format("MM/DD/YYYY | HH:mm");
          setcreatedon(formattedCreatedDate);
          setmodifiedon(formattedModifiedDate);
          setAddressDetails([
            {
              createdby,
              createdon, // Use formatted date
              modifiedby,
              modifiedon, // Use formatted date
            },
          ]);

          if (responseData.result?.logo) {
            const logoUrl = responseData.result.logo;
            const fileName = logoUrl.split('/').pop() || 'logo.png';
            
            const existingFileData = {
              file: null, 
              previewUrl: logoUrl, 
              name: fileName,
              size: 0, 
              type: getFileTypeFromUrl(logoUrl), 
              isExisting: true 
            };
            
            setUploadedFiles([existingFileData]);
            setFileInputValue(fileName);
          } else {
            setUploadedFiles([]);
            setFileInputValue("");
          }
        }
      } catch (error) {
        console.error("Error fetching header info:", error);
      }
    };

    fetchHeaderInfo();
  }, [action, currentUserData]);

  useEffect(() => {
    if (typeOption.length > 0 && stakeholderLabelTypeId) {
      const matchedOption = typeOption.find(
        (item) => item.value === String(stakeholderLabelTypeId)
      );
      setSelectedStakeholderLabel(matchedOption ? matchedOption.label : null);
      setSelectedPartyType(matchedOption ? matchedOption.label : "");
    }
  }, [typeOption, stakeholderLabelTypeId]);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    setIsAddFiles(false);
    if (!file.type.startsWith("image/")) {
      setSnackbarMessage("Please select only image file");
      setError("error");
      setSnackbarOpen(true);
      return;
    }
    
    const maxSize = 1000 * 1024 * 1024; 
    if (file.size > maxSize) {
      setSnackbarMessage("File size must be less than 1000MB");
      setError("error");
      setSnackbarOpen(true);
      return;
    }
    setSelectedImg(file);
    setFileInputValue(file.name);

    if (event.target) {
      event.target.value = "";
    }
  };

  const handleAddFile = () => {
    const file = selectedImg;
    const previewUrl = URL.createObjectURL(file);
    const newFile = {
      file,
      previewUrl,
      name: file.name,
      size: file.size,
      type: file.type,
    };

    setUploadedFiles([newFile]);
    setIsAddFiles(true);
  };

  const handleRemoveFile = (index: number) => {
    if (uploadedFiles[index].previewUrl) {
      URL.revokeObjectURL(uploadedFiles[index].previewUrl);
    }

    const newFiles = uploadedFiles.filter((_, i) => i !== index);
    setUploadedFiles(newFiles);
    setFileInputValue(newFiles.map((file) => file.name).join(", "));
    setSelectedImg([]);
    if (newFiles.length === 0 && fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.remove("drag-over");

    const files = Array.from(event.dataTransfer.files);
    if (files.length > 0) {
      const syntheticEvent = {
        target: { files: event.dataTransfer.files },
      } as React.ChangeEvent<HTMLInputElement>;
      handleFileChange(syntheticEvent);
    }
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.add("drag-over");
  };

  const handleDragLeave = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.remove("drag-over");
  };

  // Clean up object URLs when component unmounts
  useEffect(() => {
    return () => {
      uploadedFiles.forEach((file) => {
        if (file.previewUrl) {
          URL.revokeObjectURL(file.previewUrl);
        }
      });
    };
  }, [uploadedFiles]);

  const handleSave = async () => {
    setLoading(true);

    let validationMessages: string[] = [];
    if (!entityName) validationMessages.push("Entity Name is mandatory.");
    if (!stakeholderTypeId)
      validationMessages.push("\nParty Type is mandatory.");

    if (validationMessages.length > 0) {
      setSnackbarMessage(validationMessages.join(""));
      setError("error");
      setSnackbarOpen(true);
      setLoading(false);
      return;
    }

    try {
      const requestData = {
        entityName,
        stakeholderTypeId: Number(stakeholderTypeId),
        comments,
        isActive: isActive ? 1 : 0, // Convert boolean to 1/0
        createdBy: Number(loggedInUserid),
        stakeholderId:
          action === "Edit" ? currentUserData?.stakeholderid : null,
      };

       const formData = new FormData();
    
      // Append all data as form fields
      formData.append('EntityName', entityName);
      formData.append('StakeholderTypeId', String(stakeholderTypeId));
      formData.append('Comments', comments);
      formData.append('IsActive', isActive ? '1' : '0');
      formData.append('CreatedBy', String(loggedInUserid));
      
      if (action === "Edit" && currentUserData?.stakeholderid) {
        formData.append('StakeholderId', String(currentUserData.stakeholderid));
      }

      // Append the file if a new one was uploaded
      if (selectedImg && selectedImg instanceof File) {
        formData.append('File', selectedImg);
      } else if (uploadedFiles?.length > 0 && uploadedFiles[0]?.file) {
        // If file is already in uploadedFiles
        formData.append('File', uploadedFiles[0].file);
      }

      const response =
        action === "Edit"
          ? await UpdateStackHolderHeader(formData)
          : await AddStackHolderHeader(formData);
      if (response.isSuccess) {
        if (response.result.responseCode == 1) {
          const newStakeholderId = response.result.id;

          setstakeholderId(String(newStakeholderId));
          const responseData = await GetHeaderInfo(Number(newStakeholderId));
          setCurrentUserData(responseData.result || {});
          setEntityName(responseData.result.entityname || "");
          setShowEntityName(responseData.result.entityname || "");
          setStakeholderTypeId(String(responseData.result.stakeholdertypeid));
          setStakeholderLabelTypeId(
            String(responseData.result.stakeholdertypeid)
          );
          setComments(responseData.result.comments || "");
          setIsActive(responseData.result.isactive);
          setcreatedby(responseData.result.createdbyname || "");
          setmodifiedby(responseData.result.modifiedbyname || "");
          const formattedCreatedDate = moment(
            responseData.result.createdon
          ).format("MM/DD/YYYY | hh:mm A");
          const formattedModifiedDate = moment(
            responseData.result.modifieddate
          ).format("MM/DD/YYYY | hh:mm A");
          setcreatedon(formattedCreatedDate);
          setActiveKey(null);
          setmodifiedon(formattedModifiedDate);
          setAddressDetails([
            {
              createdby,
              createdon, // Use formatted date
              modifiedby,
              modifiedon, // Use formatted date
            },
          ]);

          if (action === "Edit") {
            setSnackbarMessage("Party details updated successfully!");
          } else {
            setSnackbarMessage("Party header details saved successfully!");
          }
          setError("success");
          setSnackbarOpen(true);

          if (action === "Add") {
            setAction("Edit");
          }
        } else {
          setSnackbarMessage("Entity name should be unique");
          setError("error");
          setSnackbarOpen(true);
        }
      } else {
        setSnackbarMessage("Failed to save stakeholder details");
        setError("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error saving stakeholder:", error);
      setSnackbarMessage("Error saving stakeholder.");
      setError("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };
  const [showTooltip, setShowTooltip] = useState(false);

  const handlePDFClick = () => {
    // Set the values in the state
    setShowTooltip(false);
    setAddressDetails([
      {
        createdby,
        createdon, // Use formatted date
        modifiedby,
        modifiedon, // Use formatted date
      },
    ]);

    // Show the drawer
    setShowDetails(true);
  };

  const handleCloseDrawer = () => {
    setShowDetails(false);
  };
  const closeForm = () => {
    onCancel();
  };
  // ✅ Ensure `stakeholderId` updates before passing it to StackHolderAddressList
  useEffect(() => {}, [stakeholderId]);

  const handleCancel = async () => {
    if (action === "Edit") {
      const responseData = await GetHeaderInfo(
        Number(currentUserData.stakeholderid)
      );

      setEntityName(responseData.result.entityname || "");
      setShowEntityName(responseData.result.entityname || "");
      setStakeholderTypeId(String(responseData.result.stakeholdertypeid)); // Ensure string for dropdown binding
      setStakeholderLabelTypeId(String(responseData.result.stakeholdertypeid)); // Ensure string for dropdown binding
      setComments(responseData.result.comments || "");
      setIsActive(responseData.result.isactive); // Convert API response (1/0) to boolean
    } else {
      setEntityName("");
      setShowEntityName("");
      setStakeholderTypeId("");
      setStakeholderLabelTypeId("");
      setComments("");
    }
  };

  const lastOpenedRef = useRef<number | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (lastOpenedRef.current && Date.now() - lastOpenedRef.current < 300) {
        return;
      }

      const formBottom = document
        .getElementById("team-form-buttons")
        ?.getBoundingClientRect().bottom;
      const distanceFromBottom = window.innerHeight - (formBottom ?? 0);

      // Only collapse if buttons are MORE THAN 100px from the bottom
      if (activeKey !== null && distanceFromBottom > 100) {
        setActiveKey(null);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [activeKey]);

  const renderAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
        title:
          activeKey === index.toString() ? (
            item.title
          ) : (
            <>
              {item.title}
              <span className="fw-normal">
                {showEntityName
                  ? ` - ${showEntityName} (${selectedStakeholderLabel})`
                  : ""}
              </span>
            </>
          ),
      }))}
      activeKey={activeKey}
      onSelect={(key) => {
        lastOpenedRef.current = Date.now(); // Set open time
        setActiveKey(key as string);
      }}
    />
  );

  const [isPreferenceNeeded, setIsPreferenceNeeded] = useState(false);

  useEffect(() => {
    if (
      selectedStakeholderLabel == STAKEHOLDER_TYPE.QME_Doctor ||
      selectedStakeholderLabel == STAKEHOLDER_TYPE.PMC
    ) {
      setIsPreferenceNeeded(true);
    }
  }, [selectedStakeholderLabel]);

  return (
    <div className="main_wrapper_section">
      <Container fluid className="px-5">
        <Snackbar
          message={snackbarMessage}
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />
        <div className="mt-3">
          {renderAccordion([
            {
              title: "Header",
              content: (
                <div>
                  <Row>
                    <Col sm={9}>
                      <TextInput
                        label="Entity Name"
                        name="entityName"
                        required
                        value={entityName}
                        maxLength={100}
                        onChange={(e) => {
                          setEntityName(e.target.value);
                        }}
                        disabled={!editContact}
                      />
                    </Col>
                    <Col sm={3} className="selection_dropdown">
                      <SearchableSingleSelectDropdown
                        label="Party Type"
                        name="stakeholderTypeId"
                        required
                        options={typeOption}
                        value={stakeholderTypeId}
                        onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                          setStakeholderTypeId(e.target.value);
                          const selectedOption = typeOption.find(
                            (opt) => opt.value === e.target.value
                          );
                          setSelectedPartyType(selectedOption?.label || "");
                        }}
                        disabled={action === "View" || !editContact}
                      />
                    </Col>
                    <Col sm={12} className="mt-4">
                      <MultilineTextBox
                        label="Comments"
                        name="comments"
                        value={comments}
                        maxLength={1000}
                        onChange={(e) => setComments(e.target.value)}
                        disabled={action === "View" || !editContact}
                      />
                    </Col>
                    <div className="mt-3">
                      {selectedPartyType === STAKEHOLDER_TYPE.PMC &&
                        renderAccordion([
                          {
                            title: "Logo Attachment",
                            content: (
                              <div className="row">
                                <div className="col-md-8 col-xl-9">
                                  <Form.Group className="mb-0">
                                    <div className="d-flex align-items-center">
                                      <Form.Control
                                        type="file"
                                        ref={fileInputRef}
                                        accept="image/*"
                                        multiple={false}
                                        onChange={handleFileChange}
                                        style={{ display: "none" }}
                                      />
                                      <div
                                        className="file-drop-zone flex-grow-1"
                                        onClick={() =>
                                          fileInputRef.current?.click()
                                        }
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <InputGroup>
                                          <Form.Control
                                            type="text"
                                            placeholder="Choose an image or drag it here"
                                            value={fileInputValue}
                                            readOnly
                                            className="border-end-0"
                                            style={{
                                              cursor: "pointer",
                                              height: "45px",
                                            }}
                                          />
                                          <Button
                                            variant="outline-secondary"
                                            className="p-0 border-start-0 attachbtn d-flex align-items-center"
                                            onClick={(e) => e.preventDefault()}
                                          >
                                            <span className="material-symbols-outlined color_brand mx-1">
                                              attach_file
                                            </span>
                                          </Button>
                                        </InputGroup>
                                      </div>

                                      <Button
                                        className="btn btn-primary d-flex align-items-center justify-content-center ms-2"
                                        onClick={handleAddFile}
                                        disabled={
                                          selectedImg.length === 0 ||
                                          !editContact
                                        }
                                        style={{
                                          height: "45px",
                                          minWidth: "70px",
                                        }}
                                      >
                                        <span className="material-symbols-outlined me-1 d-flex align-items-center">
                                          add_circle
                                        </span>
                                        Add
                                      </Button>
                                    </div>
                                  </Form.Group>
                                </div>

                                <div className="col-md-4 col-xl-3 borderLSide">
                                  {uploadedFiles?.length > 0 ? (
                                    <div
                                      className="logo-preview border rounded p-2 bg-white w-100"
                                      style={{
                                        width: "200px",
                                        textAlign: "center",
                                      }}
                                    >
                                      <img
                                        src={uploadedFiles[0].previewUrl}
                                        alt={uploadedFiles[0].name}
                                        className="img-fluid"
                                        style={{
                                          maxHeight: "80px",
                                          objectFit: "contain",
                                        }}
                                      />

                                      <Button
                                        variant="danger"
                                        size="sm"
                                        className="attchmentClose"
                                        style={{
                                          width: "24px",
                                          height: "24px",
                                          borderRadius: "50%",
                                          padding: "0",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                        onClick={() => handleRemoveFile(0)}
                                      >
                                        <span
                                          className="material-symbols-outlined"
                                          style={{ fontSize: "14px" }}
                                        >
                                          close
                                        </span>
                                      </Button>
                                    </div>
                                  ) : (
                                    <>
                                      <div className="logo-preview border rounded p-2 bg-white w-100 noPreview">
                                        <span className="material-symbols-outlined iconDesign">
                                          add_a_photo
                                        </span>{" "}
                                        <span className="logoPreviewrNote">
                                          Logo Preview
                                        </span>
                                        
                                      </div>
                                      <span className="noteHeadline">
                                        {" "}
                                        Supported formats:{" "}
                                        <strong>JPG, PNG</strong> — Maximum file
                                        size: <strong>1000 MB</strong>
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>
                            ),
                          },
                        ])}
                    </div>

                    <div className="mt-3">
                      <label htmlFor="isActive" className="me-2 fw-bold">
                        Is Active
                      </label>
                      <input
                        type="checkbox"
                        id="isActive"
                        className="me-2"
                        checked={isActive} 
                        onChange={(e) => setIsActive(e.target.checked)}
                        disabled={
                          action.toLowerCase() === "add" || !editContact
                        } 
                      />
                    </div>
                  </Row>
                  <OverlayDrawer
                    title={"Logs"}
                    open={showDetails}
                    onClose={handleCloseDrawer}
                    placement="bottom"
                  >
                    <DataTable
                      headers={STAKEHOLDER_LOG_HEADERS}
                      rows={addressDetails}
                      isLogTable={true}
                    />
                  </OverlayDrawer>
                  <hr />

                  <Row id="team-form-buttons">
                    <Col md={6} className="d-flex justify-content-start mb-2 ">
                      <button
                        className="btn d-flex align-items-center btn-text-border me-2"
                        onClick={closeForm}
                      >
                        <span className="material-icons">arrow_back</span>Back
                      </button>

                      {action === "Edit" && (
                        <OverlayTrigger
                          show={showTooltip}
                          placement="auto"
                          trigger={["hover", "focus"]} // Important to prevent sticky tooltip
                          delay={{ show: 200, hide: 100 }}
                          overlay={
                            <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                              Logs
                            </Tooltip>
                          }
                        >
                          <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center mx-2"
                            onClick={handlePDFClick}
                            onMouseEnter={() => setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                          >
                            <span className="material-icons">description</span>
                          </button>
                        </OverlayTrigger>
                      )}
                    </Col>
                    <Col md={6} className="d-flex justify-content-end mb-2">
                      <button
                        className="btn d-flex align-items-center me-2 btn-text"
                        onClick={handleCancel}
                      >
                        <span className="material-icons">close</span>
                        Cancel
                      </button>
                      {action !== "View" && (
                        <button
                          className="btn btn-primary ml-3 d-flex align-items-center"
                          onClick={handleSave}
                          disabled={loading || !editContact}
                        >
                          <span className="material-icons me-2">save</span>
                          Save
                        </button>
                      )}
                    </Col>
                  </Row>
                </div>
              ),
            },
          ])}

          {userData?.stakeholderid || stakeholderId ? (
            <>
              <StakeHolderTabs
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                showPreferenceTab={isPreferenceNeeded}
              />

              {/* Conditionally render components based on selectedTab */}
              {selectedTab === "Address" && (
                <StackHolderAddressList
                  userData={userData?.stakeholderid || stakeholderId}
                  action={initialAction}
                  onCancel={onCancel}
                />
              )}

              {selectedTab === "Contacts" && (
                <AddStakeHolderContact
                  userData={userData?.stakeholderid || stakeholderId}
                  action={initialAction}
                  stakeholderTypeId={stakeholderTypeId}
                  StakeholderLabel={selectedStakeholderLabel}
                  onCancel={onCancel}
                />
              )}

              {isPreferenceNeeded == true && selectedTab === "Preferences" && (
                <StakeholderPreference
                  userData={userData?.stakeholderid || stakeholderId}
                  onCancel={onCancel}
                />
              )}
            </>
          ) : null}
        </div>
      </Container>
    </div>
  );
};

export default StakeholderHeader;
